import { Injectable } from "@angular/core";
import { MerchantItems } from "../models/items";
import * as localForage from "localforage";

@Injectable({
  providedIn: "root"
})
export class MockStoreService {
  public verificationEmail: string;
  public scrambledName: string = "access_token";
  public spinner: string = `<i class="fa fa-spinner fa-spin"></i>`;
  public emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  public merchantItems: MerchantItems[] = [];
  private tokenString: string;
  public editCatalogueMode: boolean = false;
  public viewCatalagueMode: boolean = false;
  public mostRecentlyAddedItem: MerchantItems;
  public addingDirectlyFromCatalogueListing: any;
  public comingFromCatalogueListingComponent: boolean = false;
  public merchantProfileDidnotLoad: boolean = false;
  public merchantID: any;
  constructor() {
    // this.getTokenWhenRefreshIsDone();
  }

  get token() {
    return this.tokenString;
  }

  set insertToken(value) {
    this.tokenString = value;
  }

  // this function fires when there is a refresh of browser
  // getTokenWhenRefreshIsDone() {
  //   const tokenName = window.btoa(this.scrambledName);
  //   // localForage
  //   //   .getItem(tokenName)
  //   //   .then(val => (this.insertToken = val))
  //   //   .catch(err => console.log(err));
  // }
}
